import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import PaginationURL from "util/PaginationURL";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = {
  pagination: { total: 0 },
  list: [],
  attributes: []
};
export const fetchIndexSetTemplates = async (searchParams) => {
  const indexSetTemplateUrl = qualifyUrl("/system/indices/index_sets/templates/paginated");
  const url = PaginationURL(indexSetTemplateUrl, searchParams.page, searchParams.pageSize, searchParams.query, {
    filters: FiltersForQueryParams(searchParams.filters),
    sort: searchParams.sort.attributeId,
    order: searchParams.sort.direction
  });
  return fetch("GET", url).then(({ elements, total, attributes }) => ({
    list: elements,
    pagination: { total },
    attributes
  }));
};
export const keyFn = (searchParams) => ["indexSetTemplates", searchParams];
const useTemplates = (searchParams, { enabled } = { enabled: true }) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: keyFn(searchParams),
    queryFn: () => defaultOnError(
      fetchIndexSetTemplates(searchParams),
      "Loading index set templates failed with status",
      "Could not load index set templates"
    ),
    placeholderData: keepPreviousData,
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading,
    refetch
  };
};
export default useTemplates;
